import {
    RequestKeys,
} from 'app/hooks/useRequest'
import useRequestTable from 'app/hooks/useRequestTable'

import config from 'app/requests/Contact/Contact.requests'
import {
    Contact,
} from '../Contacts/Contacts.types'

import Contacts from './Contacts'

type Props = {
    isWrapped: boolean,
    value: number,
}

const ContactsContainer = ({
    isWrapped,
    value,
}: Props) => {
    const {
        data,
        onParamsChange,
    } = useRequestTable<{ data: Contact[] }>({
        key: RequestKeys.getLocationContacts,
        params: {},
        defaultValue: {
            filter: {
                locationId: [value],
            },
        },
        config: config.filterRequest,
    })

    return (
        <Contacts
            isWrapped={isWrapped}
            value={data?.data}
            onParamsChange={onParamsChange}
        />
    )
}

export default ContactsContainer
